export enum LoginContext {
  WEB,
  IOS,
  ANDROID,
  WECHAT_MINI,
}
